module.exports = __webpack_public_path__ + "media/src/components/shared/general/img/portalLogo-32d4f3179ac11bcc876ebc5228f7213c.png";